import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { TopPackagesTable } from './TopPackagesTable';
import { ErrorBoundary } from '../error-boundary/ErrorBoundary';
import { useEnhancedRpcClient } from '~/hooks/useEnhancedRpc';
import { FilterList } from '~/ui/FilterList';
import { TabHeader } from '~/ui/Tabs';

export type DateFilter = '3D' | '7D' | '30D';
export type ApiDateFilter = 'rank3Days' | 'rank7Days' | 'rank30Days';
export const FILTER_TO_API_FILTER: Record<DateFilter, ApiDateFilter> = {
	'3D': 'rank3Days',
	'7D': 'rank7Days',
	'30D': 'rank30Days',
};

export function TopPackagesCard() {
	const rpc = useEnhancedRpcClient();
	const [selectedFilter, setSelectedFilter] = useState<DateFilter>('3D');

	const { data, isLoading } = useQuery({
		queryKey: ['top-packages', selectedFilter],
		queryFn: async () => rpc.getMoveCallMetrics(),
	});

	let filteredData = data ? data[FILTER_TO_API_FILTER[selectedFilter]] : [];
	if (filteredData.length) {
		// @ts-ignore
		filteredData = filteredData.map((group) =>
			group.map((item) => {
				// @ts-ignore
				if (item && !item.module) {
					return item;
				}
				return {
					// @ts-ignore
					...item,
					// @ts-ignore
					module: item.module,
				};
			}),
		);
	}
	return (
		<div className="defined-tabs-card relative">
			<div className="pl-5">
				<FilterList
					lessSpacing
					options={['3D', '7D', '30D']}
					value={selectedFilter}
					onChange={(val) => setSelectedFilter(val)}
				/>
			</div>
			<TabHeader title="" tooltip="">
				<ErrorBoundary>
					<TopPackagesTable data={filteredData} isLoading={isLoading} />
				</ErrorBoundary>
			</TabHeader>
		</div>
	);
}
